var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticleWhatBelongsInAnMvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gwhatbelongsi",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wwhatbelongsi",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F6560",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "owhatbelongsi",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#163936"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wwhatbelongsi)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#owhatbelongsi)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 332,
    width: 460,
    height: 300,
    rx: 34,
    fill: "#2F6560",
    fillOpacity: 0.38
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 288,
    width: 460,
    height: 300,
    rx: 34,
    fill: "#2F6560",
    fillOpacity: 0.32
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 244,
    width: 460,
    height: 300,
    rx: 34,
    fill: "#2F6560",
    fillOpacity: 0.26
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 200,
    width: 460,
    height: 300,
    rx: 34,
    fill: "url(#gwhatbelongsi)",
    fillOpacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 254,
    width: 230,
    height: 10,
    rx: 5,
    fill: "#F5F8F7",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 288,
    width: 178,
    height: 10,
    rx: 5,
    fill: "#F5F8F7",
    fillOpacity: 0.38
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 322,
    width: 126,
    height: 10,
    rx: 5,
    fill: "#F5F8F7",
    fillOpacity: 0.26
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 380,
    width: 96,
    height: 30,
    rx: 15,
    fill: "#FF4804"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleWhatBelongsInAnMvp);
export default __webpack_public_path__ + "static/media/article-what-belongs-in-an-mvp.01f9ecf145b6027890964e5ad1fd3910.svg";
export { ForwardRef as ReactComponent };